<template>
  <div class="page page-strategy">
    <div class="page-title">
      Стратегия
    </div>

    <div v-if="!loaded" class="loader"></div>

    <div class="alert alert-danger"
         role="alert"
         v-if="error">
      <div><i class="fas fa-exclamation-triangle"></i>{{error}}</div>
    </div>

    <div v-if="loaded">
      <div
        class="text-center px-3"
        v-if="current.length === 0">
        {{data.length === 0 ? 'Стратегия' : 'Новая стратегия'}}
        восстановления здоровья появится после следующей консультации с доктором.
      </div>

      <StrategyList
        title=""
        :stages="current" />

      <div
        v-if="past.length > 0"
        class="page-title">
        Завершенные этапы
      </div>

      <StrategyList
        title="Завершенные этапы"
        :stages="past" />
    </div>
  </div>
</template>

<script>
import StrategyList from './strategy/List';

export default {
  name: 'Strategy',

  components: {StrategyList},

  data() {
    return {
      loaded: false,
      error: '',
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    data() {
      const data = this.$store.state.strategies.map(item => {
        let hasUnfinished = false;
        const goals = item.goals.map(goal => {

          if (!['achieved', 'canceled'].includes(goal.status)) {
            hasUnfinished = true;
          }

          return {
            id: goal.id,
            strategy: goal.strategy.title,
            status: goal.status,
          };
        });

        return {
          id: item.id,
          title: item.title,
          dateFrom: new Date(item.dateFrom),
          dateTo: new Date(item.dateTo),
          goals,
          finished: !hasUnfinished,
        };
      });

      data.sort((a, b) => a.dateFrom.getTime() - b.dateFrom.getTime());

      return data;
    },

    current() {
      return this.data.filter(i => i.finished === false);
    },

    past() {
      return this.data.filter(i => i.finished === true);
    },
  },

  methods: {
    async loadData() {
      this.loaded = false;
      this.error = '';

      try {
        await this.$store.dispatch('LOAD_STRATEGIES');
      } catch(e) {
        this.error = 'Произошла ошибка. Повторите попытку позже.';
      }

      this.loaded = true;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.page-strategy {
}
</style>
